import axios, { AxiosError } from 'axios';
import store from '@/store/store';
import router from '../router';

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8';

axios.interceptors.request.use((request: any) => {
	let jwtToken = (store.state as any).AuthModule.token;
	if (jwtToken) {
		request.headers.Authorization = `Bearer ${jwtToken}`;
	} else {
		request.headers.Authorization = null;
	}

	return request;
}, (error: any) => {
   console.error('Error in interceptors of request');
   console.error(error);
});

axios.interceptors.response.use((response: any) => {
	if (!!response.headers['refresh-token']) {
		store.commit('AuthModule/setToken', response.headers['refresh-token']);
	}
	return response;
}, (error: any) => {

	let getErrorMsg = (err: AxiosError) => {
		if (err.response?.data?.error?.message) return err.response.data.err.message;
		if (err.response?.data?.error) return err.response?.data?.error;
		if (err.response?.data?.message) return err.response?.data.message;
	};

	let redirectFromError = (err: AxiosError) => {
		if (err.response?.data?.redirect) {
			router.replace({ path: `/${err.response.data.redirect}` });
		}
	}

	// // As per https://github.com/axios/axios/issues/383, HTTP 401 is considered a network error
	// // and axios is unable to give the specific status code / error details. This will check for network error.
	// if (!error.response?.status) {
	// 	store.commit('AuthModule/setToken', null);
	// 	store.commit('AuthModule/setUsername', null);
	// 	store.commit('AuthModule/setName', null);
	// 	store.commit('AuthModule/setRole', null);

	// 	// redirect to login page
	// 	router.replace({ path: '/Login' });
	// }

	// Global error handling
	if (error.response && !( error.config.hasOwnProperty('errorHandle') && error.config.errorHandle === false)) {
		if (error.response.status===401) {
			router.replace({ path: '/Login' });
		}
		else {
			redirectFromError(error);

			// const vm = new Vue()
			// vm.$bvToast.toast(getErrorMsg(error), {
			//   title: 'Error',
			//   variant: 'danger',
			//   noAutoHide: true,
			//   appendToast: true,
			//   toaster: 'b-toaster-top-full'
			// });
		}
	}

	return Promise.reject(error);
});

export default axios;
